import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import tokens from '../theme/tokens';

// 개인회원 / 기업회원 탭 — 로그인·회원가입 맨 위. 알약 틀 안에서 고른 쪽만 흰 카드로 떠오른다
export const MEMBER_TABS = [
  { value: 'Private', label: '개인회원' },
  { value: 'Company', label: '기업회원' },
];

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    width: '100%',
    padding: 4,
    borderRadius: 14,
    backgroundColor: tokens.surfaceSoft,
  },
  tab: {
    flex: '1 1 0',
    height: 44,
    borderRadius: 11,
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: -0.6,
    color: tokens.muted,
    transition: 'background-color .15s, color .15s, box-shadow .15s',
    '&:hover': { color: tokens.text },
  },
  on: {
    backgroundColor: tokens.surface,
    color: tokens.ink,
    boxShadow: '0 2px 8px rgba(22, 22, 23, 0.08)',
  },
}));

function AuthTabs({ value, onChange, items = MEMBER_TABS, className }) {
  const cs = useStyles();
  return (
    <div className={clsx(cs.root, className)} role="tablist">
      {items.map((t) => (
        <ButtonBase
          key={t.value}
          role="tab"
          aria-selected={value === t.value}
          className={clsx(cs.tab, value === t.value && cs.on)}
          onClick={() => onChange(t.value)}
          focusRipple={false}
        >
          {t.label}
        </ButtonBase>
      ))}
    </div>
  );
}

export default AuthTabs;
